export default function initGroupRequiredValidator() {
    $.validator.addMethod("grouprequired", function (value, element) {
        // Walk up to the group container emitted by the shared Group editor
        // template, then check whether any choice input inside is selected.
        // Works for both checkbox groups and radio groups.
        const group = element.closest("[data-group-required='true']");
        if (!group) return true;
        return !!group.querySelector(
            "input[type='checkbox']:checked, input[type='radio']:checked"
        );
    });
    $.validator.unobtrusive.adapters.add("grouprequired", [],
        function (options) {
            options.rules["grouprequired"] = true;
            options.messages["grouprequired"] = options.message;
        }
    );
}